import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import { styled } from "@mui/material";
import * as Yup from "yup";
import { Field, FormikProvider, FormikValues, useFormik } from "formik";
import Button from "../../../../customs/Button";
import Input from "../../../../customs/FormInput";
import Select from "../../../../customs/SelectInput";
import CustomTextArea from "../../../../customs/textarea";
import apiCall from "../../../../utils/apiCall";
import { NotificationContext } from "../../../../providers/notification";
import {ExNyRoute, PrRoute, ExRoute, AcRoute, MiRoute, CoRoute} from '../../../../utils/allRouteId'
import { RouteResponse, Route } from "../../../../types";
import { reOrderFetchedData } from "../../../../hooks/FetchData";





interface CreateExamEntryLevelPayload {
  Id?: number;
  Name: string;
  RouteId: number;
  ExamAmount: number;
  ExemptionAmount: number;
  IsActive?: boolean;
}
interface ScoreTypeData{
    Name: number;
    ScoreTypeId: string;
}
interface ComponentProps {
    handleClose: () => void;
}


const option1:any[]= [
    // {val:1, name:"Memembership Route",path:`${BASE_URL}`},
     {val:ExNyRoute, name:"Examination / NYSC"},
    {val:PrRoute, name:"Practitioner"},
    {val:ExRoute, name:"Executive"},
    {val:AcRoute, name:"Academic"},
    {val:MiRoute, name:"Military"},
    {val:CoRoute, name:"Corporate"}
  ]
const CreateExamEntryLevelSetUp: React.FC<ComponentProps> = ({ handleClose }) => {
    const queryClient = useQueryClient();
    const { showNotification } = useContext(NotificationContext);
    // const GetAllScoreTypes = async (): Promise<any> => {
    //     return await apiCall().get(`/SetUp/GetAllScoreTypes`);
    // }

    // const { data, isLoading, isError, error } = useQuery(['get-scoretype'], GetAllScoreTypes, {
	// 	refetchOnWindowFocus: false,
	// 	retry: 1,
	// });


    const getAllRoutes = async (): Promise<RouteResponse> => {
        return (await apiCall().get('/Routes/GetAllRoute'))?.data
    };

    const { data, isLoading, isError, error } = useQuery(['get-all-route'], getAllRoutes, {
        enabled: true,
        keepPreviousData: true,
        retry: 0
    });
    
    

  const createExamEntryLevel = async (payload: CreateExamEntryLevelPayload) => {
    return await apiCall().post(
      '/SetUp/CreateUpdateExemption',
      payload
    );
  };

  const createExamEntryLevelMutation = useMutation(
    ["create-exam-enty-level"],
    createExamEntryLevel,
    { retry: 0 }
  );

  const createExamEntryLevelHandler = async (
    values: FormikValues,
    resetForm: () => void
  ) => {
    const createExamEntryLevelPayload: CreateExamEntryLevelPayload = {
        Name: values?.name,
        RouteId: values?.routeId,
        ExamAmount: values?.examAmount,
        ExemptionAmount: values?.exemptionAmount
    };

    try {
      await createExamEntryLevelMutation.mutateAsync(createExamEntryLevelPayload, {
        onSuccess: () => {    
            showNotification({
                message: 'Exam Entry Level created successful',
                type: 'success',
            });
            queryClient.refetchQueries(["get-All-Exam-Entry-Level"]);
            handleClose();
        },
      });
      
    } catch (error: any) {
      showNotification({
        message: error?.response?.data?.Message || error?.message,
        type: "error",
      });
    }
  };

    const validationSchema = Yup.object().shape({
        name:Yup.string().required('Name is required'),
        examAmount: Yup.number().typeError('Only numbers are allowed').required('Exam Amount is required'),
        exemptionAmount: Yup.number().typeError('Only numbers are allowed').required('Exemption Amount is required'),
    })
    const formik = useFormik<FormikValues>({
        initialValues: {
            name: '',
            examAmount: '',
            exemptionAmount: '',
            routeId: '',
        },
        onSubmit: (values, { resetForm }) => {
            createExamEntryLevelHandler(values, resetForm);
        },
        validationSchema,
    });

    const routeOption =
    data?.Data && data?.Data?.length > 0 ? (
       reOrderFetchedData(data?.Data).map((route : Route ) => (
                <option value={route?.RouteId} key = {route?.RouteId} >
                    {route?.RouteName}
                </option>
            ))
        ) : (
            <option disabled>
                {isLoading ? 'loading....' : isError ? 'error': ''}
            </option>
    );

   
    return (
        <FormikProvider value={formik}>
            <form onSubmit={formik.handleSubmit}>
                <FormWrapper>
                    <Field 
                        name='name'
                        type='text'
                        as={Input}
                        label='Name'
                        placeholder='Name'
                    />
                    <Field 
                        name='examAmount'
                        type='number'
                        as={Input}
                        label='Exam Amount'
                        placeholder='Exam Amount'
                    />
                     <Field 
                        name='exemptionAmount'
                        type='text'
                        as={Input}
                        label='Exemption Amount'
                        placeholder='Enter Amount'
                    />
                    <Field 
                        name='routeId'
                        type='text'
                        as={Select}
                        label='Route Name'
                        options = {routeOption}
                        placeholder='Route Name'
                    />
                                       
                </FormWrapper>
              
                <ButtonWrapper>
                    <ButtonContainer>
                        <StyledButton text='Cancel' onClick={handleClose}/>
                        <StyledButton 
                            disabled={createExamEntryLevelMutation.isLoading} 
                            text={createExamEntryLevelMutation.isLoading ? "Submitting..." : "Submit"}
                            onClick={formik.handleSubmit} 
                            type="submit"
                        />
                    </ButtonContainer>
                </ButtonWrapper>
              
            </form>
        </FormikProvider>
    )
};


export default CreateExamEntryLevelSetUp;

const FormWrapper = styled('div')`
    margin-inline: 3.5rem;
`

const ButtonWrapper = styled('div')`
    display: flex;
    justify-content: flex-end;
    margin-block: 2.5rem;
    padding-inline: 3.5rem;
`

const ButtonContainer = styled('div')`
    display: flex;
    gap: 2rem;
`

const StyledButton = styled(Button)`
    padding-block: 1rem;
    padding-inline: 2rem;
`

